import { useState } from "react";
import { Input, Form, Modal, Typography, App } from "antd";

import { changePassword } from "@/api/auth";

const { Text } = Typography;

// Окно для смены пароля
const ChangePasswordModal = ({
  data = {},
  visible,
  onSave,
  onCancel,
  uuid = "",
}) => {
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    try {
      const res = await changePassword(
        values.password,
        values.newPassword,
        uuid
      );

      message.open({
        type: "warning",
        content: res.message,
        duration: 10,
      });
      onSave();
      form.resetFields();

      if (!uuid) {
        setTimeout(() => {
          window.location.href = "/login";
        }, 1000);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });
  };

  return (
    <Modal
      maskClosable={false}
      title="Сменить пароль"
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText="Сохранить"
      cancelText="Отменить"
      okButtonProps={{ loading: isLoading }}
      width={350}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={data}
        onFinish={handleSave}
      >
        {!uuid && (
          <Form.Item
            name="password"
            label="Старый пароль"
            rules={[
              {
                required: !uuid,
                message: "Пожалуйста, введите текущий пароль",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
        )}
        <Form.Item
          name="newPassword"
          label="Новый пароль"
          rules={[
            { required: true, message: "Пожалуйста, введите новый пароль" },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="newPassword2"
          label="Подтверждение нового пароля"
          rules={[
            { required: true, message: "Пожалуйста, введите новый пароль" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Пароли не совпадают"));
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        {error && (
          <div>
            <Text type="danger">{error}</Text>
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
